import type { TextEditorWithErrorDisplayProps } from '~/features/rich-text-editor';
import type { TEXT_EDITOR_MODES } from '~/features/rich-text-editor/constants';
import { P, Stack } from '@workramp/ui';
import { useEffect, useState } from 'react';
import { TextEditorWithErrorDisplay } from '~/features/rich-text-editor';
import { useDebouncedCallback } from '~/hooks';

interface RichTextSettingProps extends TextEditorWithErrorDisplayProps {
  mode?: keyof typeof TEXT_EDITOR_MODES;
  label?: string;
}

export const RichTextSetting = ({ label, value, onChange, mode = 'THEME_EDITOR', ...props }: RichTextSettingProps) => {
  const [controlledValue, setControlledValue] = useState(value);
  const debouncedChange = useDebouncedCallback(() => onChange(controlledValue));

  useEffect(() => {
    setControlledValue(value);
  }, [value]);

  const handleOnChange = (v: string) => {
    setControlledValue(v);
    debouncedChange();
  };

  return (
    <Stack size={2}>
      {label && (
        <P weight="medium" density="lg" size={1}>
          {label}
        </P>
      )}
      <TextEditorWithErrorDisplay mode={mode} {...props} onChange={handleOnChange} value={controlledValue} />
    </Stack>
  );
};
